import React from "react";
import { Container, Row, Col } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { useLocation } from "react-router-dom";

function DF_OT0053(props) {
  document.title = "Defender | Editar Local de Entrega";

  const location = useLocation();
  const rowData = location.state?.rowData ?? null;

  return (
    <>
      <div className="page-content" style={{ backgroundColor: "#f4f5f7", minHeight: "100vh" }}>
        <Container fluid={true} className="dataTable-custom-primary">
          <Row className="mb-2">
            <Col lg={12}>
              <h4 className="font-size-24 font-w-600 text-color-azul1 mb-4">
                Editar Local de Entrega
              </h4>

              <div
                className="card p-4 mb-4"
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #e8e8e8",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  borderRadius: "8px",
                }}
              >
                <GridBody rowData={rowData} />
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default withRouter(DF_OT0053);